import { render, staticRenderFns } from "./text-tile.vue?vue&type=template&id=65f73230&scoped=true&"
import script from "./text-tile.vue?vue&type=script&lang=js&"
export * from "./text-tile.vue?vue&type=script&lang=js&"
import style0 from "./text-tile.vue?vue&type=style&index=0&id=65f73230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f73230",
  null
  
)

export default component.exports